module.exports = __webpack_public_path__ + "img/pattern1.268b051.svg";